/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Person = props => (
  <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
    <switch>
      <g>
        <path d="M29.988 46.279s.362 6.601 6.463 13.67v.004c1.285 1.561 6.268 7.052 12.909 7.327 4.881.183 9.753-2.456 14.504-7.906l.008.007c5.645-6.849 6.01-13.102 6.01-13.102s3.308.552 5.145-7.348c1.836-7.9-1.837-6.061-1.837-6.061C77.963 7.894 58.472 1.097 58.472 1.097 54.893.019 52.084-.132 49.935.087c-2.143-.22-4.958-.068-8.533 1.01 0 0-19.492 6.797-14.717 31.773 0 0-3.672-1.84-1.836 6.061 1.836 7.9 5.139 7.348 5.139 7.348z" />
        <path d="M98.11 92.008c-4.041-10.652-10.469-12.671-15.612-13.587-5.14-.92-17.632-4.045-18.73-6.979-.37-.989-.487-2.915-.485-5.026-4.297 3.627-8.782 5.464-13.392 5.464-.253 0-.506-.007-.759-.018-5.23-.228-9.481-2.77-12.413-5.195-.007 2.012-.129 3.824-.484 4.775-1.099 2.935-13.591 6.06-18.731 6.979-5.144.916-11.572 2.935-15.613 13.587-4.041 10.656 100.26 10.656 96.219 0z" />
      </g>
    </switch>
  </svg>
);
export default extendIcon(Person);
